/**
 * The file name of a `Content-Disposition` header (RFC 6266): `filename*` (RFC 5987, UTF-8
 * percent-encoded) first, then `filename`, quoted or not. `null` when there is none or the
 * encoded one cannot be decoded and no plain one is given. Path parts are dropped.
 */
export function contentDispositionFileName(header: string | null): string | null {
  if (!header) return null
  const encoded = /filename\*\s*=\s*([^']*)'[^']*'([^;]+)/i.exec(header)
  if (encoded?.[2] && /^utf-8$/i.test(encoded[1]?.trim() ?? '')) {
    try {
      return baseName(decodeURIComponent(encoded[2].trim().replace(/^"|"$/g, '')))
    } catch {
      // Malformed encoding: fall back to the plain name.
    }
  }
  const plain = /(?:^|;)\s*filename\s*=\s*(?:"((?:[^"\\]|\\.)*)"|([^;]+))/i.exec(header)
  const name = plain?.[1]?.replace(/\\(.)/g, '$1') ?? plain?.[2]?.trim()
  return name ? baseName(name) : null
}

/** The last path part; an empty one (a name ending in a slash) is no name. */
function baseName(name: string): string | null {
  const last = name.split(/[\\/]/).pop()
  return last !== undefined && last !== '' ? last : null
}
